var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ui checkbox" }, [
    _c("input", {
      attrs: { type: "checkbox", id: _vm.id, name: _vm.name },
      on: { change: _vm.onChange },
    }),
    _vm._v(" "),
    _c("label", [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }